export const assessments = {
  week1: {
    title: "Post Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Why is Social-Emotional Learning (SEL) considered a key part of student development in today's classrooms?",
        options: [
          {
            id: "A",
            text: "Because it focuses on replacing academic subjects with life skills that are more relevant to students' emotions.",
          },
          {
            id: "B",
            text: "Because it offers tools for students to navigate their emotions, build healthy relationships, and make thoughtful decisions.",
          },
          {
            id: "C",
            text: "Because it guarantees an end to conflict in school environments.",
          },
          {
            id: "D",
            text: "Because it directly boosts test scores by focusing solely on behavior management.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Which of the following best illustrates an area that is outside the core focus of Social-Emotional Learning (SEL)?",
        options: [
          {
            id: "A",
            text: "Helping students identify their feelings and regulate their emotional responses.",
          },
          {
            id: "B",
            text: "Encouraging learners to form supportive peer connections and resolve conflicts peacefully.",
          },
          {
            id: "C",
            text: "Teaching students to recall and retain subject-specific information for exams.",
          },
          {
            id: "D",
            text: "Guiding learners to weigh consequences and make ethical, constructive choices.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question:
          "In what context does Social-Emotional Learning (SEL) have the greatest long-term impact on students?",
        options: [
          {
            id: "A",
            text: "When it's treated as a separate subject taught once a week.",
          },
          {
            id: "B",
            text: "When it's woven consistently into classroom routines, teaching methods, and teacher-student interactions.",
          },
          {
            id: "C",
            text: "When it's introduced as a response to challenging student behavior.",
          },
          {
            id: "D",
            text: "When it's offered as a support strategy only for students struggling socially or emotionally.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question:
          "Which of the following classroom practices best demonstrates an educator's self-awareness?",
        options: [
          {
            id: "A",
            text: "Changing instructional methods only when student performance declines.",
          },
          {
            id: "B",
            text: "Not showing personal emotions to maintain a professional image.",
          },
          {
            id: "C",
            text: "Noticing moments of personal frustration and intentionally responding in calm, constructive ways.",
          },
          {
            id: "D",
            text: "Responding to misbehavior primarily with firm rules and consequences.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 5,
        question:
          "In what way does Positive Psychology meaningfully support the goals of Social-Emotional Learning (SEL)?",
        options: [
          {
            id: "A",
            text: "By identifying and correcting students' emotional and behavioral problems.",
          },
          {
            id: "B",
            text: "By prioritizing the repair of weaknesses before building other skills.",
          },
          {
            id: "C",
            text: "By encouraging a strengths-based approach that highlights gratitude, resilience, and overall well-being.",
          },
          {
            id: "D",
            text: "By minimizing the role of emotions in learning environments.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 6,
        question:
          "Why might many people struggle to identify their personal strengths compared to their weaknesses?",
        options: [
          {
            id: "A",
            text: "Because they believe weaknesses are more important to acknowledge and correct.",
          },
          {
            id: "B",
            text: "Because they've had more practice noticing flaws than recognizing what they do well.",
          },
          {
            id: "C",
            text: "Because strengths are rarely discussed or valued in learning environments.",
          },
          {
            id: "D",
            text: "Because strengths don't play a meaningful role in personal or academic growth.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 7,
        question:
          "Which of the following teaching practices best reflects a strengths-based approach in the classroom?",
        options: [
          {
            id: "A",
            text: "Focusing recognition on students with the highest academic scores.",
          },
          {
            id: "B",
            text: "Noticing and nurturing each student's unique qualities, efforts, and growth areas.",
          },
          {
            id: "C",
            text: "Giving the same praise to all students to keep the environment positive.",
          },
          {
            id: "D",
            text: "Minimizing corrective feedback to avoid hurting students' confidence.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 8,
        question:
          "What is one meaningful way gratitude can shape student behavior and classroom engagement?",
        options: [
          {
            id: "A",
            text: "It helps reduce stress levels, strengthens peer relationships, and boosts emotional well-being.",
          },
          {
            id: "B",
            text: "It leads students to comply more strictly with classroom rules and authority figures.",
          },
          {
            id: "C",
            text: "It replaces the need for teaching conflict resolution or emotional regulation skills.",
          },
          {
            id: "D",
            text: "It tends to benefit students who are already performing well academically.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 9,
        question: `A student expresses frustration during a lesson, saying, "I just can't do this." Which of the following teacher responses best reflects the application of Social-Emotional Learning and Positive Psychology?`,
        options: [
          {
            id: "A",
            text: "Let's take a moment to remember something you've done well before, maybe we can use that as a starting point.",
          },
          {
            id: "B",
            text: "Try not to think too much about it. Just move on to the next activity.",
          },
          {
            id: "C",
            text: "Why don't you let your classmate handle this one so we can keep moving?.",
          },
          {
            id: "D",
            text: "We'll talk about this later,  let's focus on something else right now..",
          },
        ],
        correctOption: "A",
      },
      {
        id: 10,
        question:
          "Why is it important for educators to practice SEL in their own lives?",
        options: [
          {
            id: "A",
            text: "To avoid engaging emotionally with students and completely miss SEL's true purpose.",
          },
          {
            id: "B",
            text: "To fulfill mandated requirements for social-emotional learning within the curriculum.",
          },
          {
            id: "C",
            text: "To manage their own emotions and demonstrate healthy coping strategies to students.",
          },
          {
            id: "D",
            text: "To foster genuine relationships, model emotional skills, and support classroom culture.",
          },
        ],
        correctOption: "D",
      },
    ],
  },
  week2: {
    title: "Post-Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Which of the following situations is most likely to serve as an emotional trigger for a teacher during a lesson?",
        options: [
          {
            id: "A",
            text: "A student respectfully asks for clarification on an assignment.",
          },
          {
            id: "B",
            text: "A student openly refuses to follow directions despite repeated requests.",
          },
          {
            id: "C",
            text: "A student quietly completes their tasks before the allotted time.",
          },
          {
            id: "D",
            text: "A student remains focused and attentive throughout the class.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Which of the following is a key purpose of naming emotions when supporting emotional regulation?",
        options: [
          {
            id: "A",
            text: "It allows the individual to pause long enough to ignore the emotion and move on.",
          },
          {
            id: "B",
            text: "It creates distance from the emotion by pushing it aside until later.",
          },
          {
            id: "C",
            text: "It helps the individual gain clarity and control by accurately identifying what they’re feeling.",
          },
          {
            id: "D",
            text: "It shifts focus away from the emotion to avoid reacting impulsively.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question:
          "Which emotional regulation strategy involves taking a deep breath and pausing before reacting?",
        options: [
          {
            id: "A",
            text: "“Stop” – slowing down to break the cycle of reaction.",
          },
          {
            id: "B",
            text: "“Observe” – watching the student closely for further signs.",
          },
          {
            id: "C",
            text: "“Ask” – clarifying the student’s intent before responding.",
          },
          {
            id: "D",
            text: "“Regulate” – modifying your tone and body language in the moment.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 4,
        question:
          "What is the main goal of emotional regulation in the classroom?",
        options: [
          {
            id: "A",
            text: "To manage emotions in a way that supports learning and positive relationships.",
          },
          {
            id: "B",
            text: "To minimize classroom disruptions by keeping emotions hidden.",
          },
          {
            id: "C",
            text: "To encourage students to suppress negative emotions and stay composed.",
          },
          {
            id: "D",
            text: "To create a neutral environment where emotions are discouraged.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 5,
        question:
          "Which of the following teacher responses most effectively supports a student’s emotional growth when they express frustration in class?",
        options: [
          {
            id: "A",
            text: "Calmly acknowledge the student’s frustration, then guide them toward a constructive next step.",
          },
          {
            id: "B",
            text: "Remind the student that frustration is part of learning and suggest they keep working silently.",
          },
          {
            id: "C",
            text: "Redirect the class’s attention to avoid reinforcing emotional outbursts.",
          },
          {
            id: "D",
            text: "Encourage the student to take a break outside to cool off and reflect on their behavior.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 6,
        question:
          "In the SONAR Pathway, what deeper purpose does the 'Name' step serve when supporting emotional regulation?",
        options: [
          {
            id: "A",
            text: "It helps the teacher quickly move on from uncomfortable emotions.",
          },
          {
            id: "B",
            text: "It labels the emotion, creating awareness and reducing its intensity by bringing it into focus.",
          },
          {
            id: "C",
            text: "It allows students to suppress emotions so they don’t disrupt learning.",
          },
          {
            id: "D",
            text: "It shifts attention away from emotions toward academic tasks.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 7,
        question:
          "What is an example of a de-escalation strategy when emotions are escalating?",
        options: [
          {
            id: "A",
            text: "Raise your voice loudly to assert control and remind students who is in charge.",
          },
          {
            id: "B",
            text: "Speak in a calm but firm tone while pausing to take a deep breath and regulate your own emotions.",
          },
          {
            id: "C",
            text: "Step back and avoid engaging so students can manage the situation on their own.",
          },
          {
            id: "D",
            text: "Delay addressing the emotion until after the lesson to keep the class on track.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 8,
        question:
          "Deep breathing is a common self-regulation strategy. For which of the following emotional states is it typically most effective?",
        options: [
          {
            id: "A",
            text: "When a student is excited and full of positive energy before an activity.",
          },
          {
            id: "B",
            text: "When a student is feeling overwhelmed, tense, and experiencing racing thoughts.",
          },
          {
            id: "C",
            text: "When a student is feeling joyful and needs to stay calm.",
          },
          {
            id: "D",
            text: "When a student is quietly withdrawn and struggling with low energy.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 9,
        question:
          "How can emotional regulation positively impact your classroom?",
        options: [
          {
            id: "A",
            text: "It helps maintain order by limiting emotional expression, allowing lessons to stay on track.",
          },
          {
            id: "B",
            text: "It creates a climate where students feel emotionally safe, focused, and ready to learn.",
          },
          {
            id: "C",
            text: "It reduces the teacher’s control over students by shifting focus to emotional needs.",
          },
          {
            id: "D",
            text: "It encourages students to manage emotions on their own without teacher involvement.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 10,
        question:
          "During a lesson, you begin to feel rising frustration. What is the most effective initial response in line with emotional regulation practices?",
        options: [
          {
            id: "A",
            text: "Push through the lesson without acknowledging the emotion so you don’t lose control.",
          },
          {
            id: "B",
            text: "Pause briefly to take a deep breath and apply a calming strategy to reset your focus.",
          },
          {
            id: "C",
            text: "Direct students to settle down immediately so you can regain control of the class.",
          },
          {
            id: "D",
            text: "Suppress the feeling until the end of the lesson and deal with it privately later.",
          },
        ],
        correctOption: "B",
      },
    ],
  },
  week3: {
    title: "Post-Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Why are strong teacher-student relationships considered foundational to effective learning?",
        options: [
          {
            id: "A",
            text: "They foster a sense of emotional safety and trust, which supports engagement and risk-taking.",
          },
          {
            id: "B",
            text: "They lead students to follow instructions more consistently, reducing the need for discipline.",
          },
          {
            id: "C",
            text: "They give teachers greater influence over student behavior and decision-making.",
          },
          {
            id: "D",
            text: "They make students more likely to comply with classroom routines and academic demands.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 2,
        question:
          "How can teachers build positive connections with students on a daily basis?",
        options: [
          {
            id: "A",
            text: "By consistently showing care for students’ development through intentional check-ins and positive interactions.",
          },
          {
            id: "B",
            text: "By tracking students’ academic performance as the main indicator of growth and engagement.",
          },
          {
            id: "C",
            text: "By keeping conversations strictly academic to avoid blurring professional boundaries.",
          },
          {
            id: "D",
            text: "By minimizing informal exchanges to maintain discipline and authority in the classroom.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 3,
        question:
          "What is an important strategy for demonstrating active listening?",
        options: [
          {
            id: "A",
            text: "Waiting patiently for the student to finish before offering clarification or correction.",
          },
          {
            id: "B",
            text: "Making eye contact, listening fully, and responding in a way that shows you understand.",
          },
          {
            id: "C",
            text: "Planning what to say next so you can guide the student toward the right answer.",
          },
          {
            id: "D",
            text: "Reducing eye contact so the student feels less pressure while speaking.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question:
          "What type of praise is most effective for encouraging student motivation?",
        options: [
          {
            id: "A",
            text: "Highlighting a student’s consistent effort and growth to reinforce a sense of personal progress.",
          },
          {
            id: "B",
            text: "Praising students by pointing out how they’re doing better than others in the class.",
          },
          {
            id: "C",
            text: "Focusing praise on flawless work to set a high standard for success.",
          },
          {
            id: "D",
            text: "Waiting to offer praise until students seek it out to avoid giving too much attention.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 5,
        question:
          "Which of the following is an example of effective positive reinforcement?",
        options: [
          {
            id: "A",
            text: "Acknowledging a student’s specific behavior by linking it to a positive value or class norm.",
          },
          {
            id: "B",
            text: "Pointing out what a student should already know to motivate them to try harder.",
          },
          {
            id: "C",
            text: "Offering a reward if the student performs well to encourage better results.",
          },
          {
            id: "D",
            text: "Comparing a student’s behavior to others in the class to highlight expectations.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 6,
        question:
          "What is the main goal of restorative practices in classroom conflict resolution?",
        options: [
          {
            id: "A",
            text: "To ensure consequences are felt strongly enough to prevent future misbehavior.",
          },
          {
            id: "B",
            text: "To repair harm by helping those involved reflect, take responsibility, and rebuild trust.",
          },
          {
            id: "C",
            text: "To maintain order by removing students who disrupt the learning environment.",
          },
          {
            id: "D",
            text: "To reinforce the teacher’s authority by gaining student agreement on the outcome.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 7,
        question:
          "Which of the following is a key step in a restorative conversation?",
        options: [
          {
            id: "A",
            text: "Removing the student from the space to avoid further disruption before addressing the issue.",
          },
          {
            id: "B",
            text: "Prioritizing the rules over the student’s feelings to maintain consistency.",
          },
          {
            id: "C",
            text: "Inviting the student to reflect on the impact of their actions on others involved.",
          },
          {
            id: "D",
            text: "Pointing out what the student did wrong and explaining why it warrants guilt.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 8,
        question:
          "How can teachers encourage students to take responsibility during conflict resolution?",
        options: [
          {
            id: "A",
            text: "Requiring a quick apology to restore order and move on.",
          },
          {
            id: "B",
            text: "Creating space for reflection and helping students explore the impact of their actions on others.",
          },
          {
            id: "C",
            text: "Applying consequences promptly to discourage repeated behavior.",
          },
          {
            id: "D",
            text: "Choosing not to address the issue to prevent further disruption in the moment.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 9,
        question: "Why is positive reinforcement important in the classroom?",
        options: [
          {
            id: "A",
            text: "It strengthens desirable behaviors by helping students connect effort with positive outcomes.",
          },
          {
            id: "B",
            text: "It allows teachers to reward good behavior selectively, depending on the student.",
          },
          {
            id: "C",
            text: "It reduces the workload of lesson planning by keeping students better behaved.",
          },
          {
            id: "D",
            text: "It motivates students by encouraging them to seek praise and outperform their peers.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 10,
        question:
          "Which of the following is NOT an example of active listening?",
        options: [
          {
            id: "A",
            text: "Giving occasional nods and saying things like “I understand” while the student speaks.",
          },
          {
            id: "B",
            text: "Asking questions to better understand the student's perspective.",
          },
          {
            id: "C",
            text: "Glancing at your phone briefly while the student talks, as long as you’re still hearing them.",
          },
          {
            id: "D",
            text: "Summarizing what the student said to show that you were listening attentively.",
          },
        ],
        correctOption: "C",
      },
    ],
  },
  week4: {
    title: "Post-Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "What is a core belief of a growth mindset?",
        options: [
          {
            id: "A",
            text: "Intelligence is mostly genetic and doesn't change much over time.",
          },
          {
            id: "B",
            text: "Talent determines long-term success more than anything else.",
          },
          {
            id: "C",
            text: "Abilities can be developed through effort, strategy, and support.",
          },
          {
            id: "D",
            text: "Failure proves someone lacks the natural ability to succeed.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 2,
        question: "Which of the following is a fixed mindset statement?",
        options: [
          { id: "A", text: "I haven’t figured this out yet, but I will." },
          {
            id: "B",
            text: "This is too hard; I’ll probably never be able to do it.",
          },
          { id: "C", text: "I learn more every time I make a mistake." },
          { id: "D", text: "If I keep practicing, I’ll improve eventually." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question:
          "What is the biggest difference between a fixed mindset and a growth mindset?",
        options: [
          {
            id: "A",
            text: "One focuses on academic success, the other focuses on behavior.",
          },
          {
            id: "B",
            text: "One believes failure is a sign of limits, the other sees failure as a learning opportunity.",
          },
          {
            id: "C",
            text: "One is used in math, the other is better for creative subjects.",
          },
          {
            id: "D",
            text: "One helps students feel good, the other emphasizes hard work.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "Which of the following best fosters grit in students?",
        options: [
          {
            id: "A",
            text: "Recognizing only students who consistently succeed.",
          },
          {
            id: "B",
            text: "Offering rewards each time a student completes an easy task.",
          },
          {
            id: "C",
            text: "Encouraging students to stick with challenges, even when progress is slow.",
          },
          {
            id: "D",
            text: "Allowing students to switch tasks if they’re struggling.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 5,
        question: "What role does optimism play in building resilience?",
        options: [
          {
            id: "A",
            text: "It allows us to avoid feeling discouraged altogether.",
          },
          {
            id: "B",
            text: "It shifts our focus to strengths and overlooks weaknesses.",
          },
          {
            id: "C",
            text: "It helps us believe setbacks are temporary and we can overcome them.",
          },
          {
            id: "D",
            text: "It makes it easier to ignore failure and move on quickly.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 6,
        question: "A growth mindset helps educators to:",
        options: [
          {
            id: "A",
            text: "Stick with tried-and-true methods to reduce classroom risk.",
          },
          {
            id: "B",
            text: "Embrace challenges in teaching and model learning from mistakes.",
          },
          {
            id: "C",
            text: "Avoid challenges so students don’t feel overwhelmed.",
          },
          {
            id: "D",
            text: "Focus on mastering curriculum delivery above all else.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 7,
        question: "Reflecting on past challenges helps educators to:",
        options: [
          {
            id: "A",
            text: "Avoid difficult situations in the future by planning better.",
          },
          { id: "B", text: "Revisit old failures and try to fix them." },
          {
            id: "C",
            text: "Appreciate how far they’ve come and build confidence.",
          },
          {
            id: "D",
            text: "Confirm that teaching is inherently difficult and draining.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 8,
        question:
          "What advice might you give your younger teaching self based on resilience reflection?",
        options: [
          {
            id: "A",
            text: "Make things as easy as possible to avoid burnout.",
          },
          {
            id: "B",
            text: "Stay safe—don’t take chances in your teaching style.",
          },
          {
            id: "C",
            text: "Each challenge you face is shaping you into a stronger educator.",
          },
          { id: "D", text: "Stick with what others are doing; it’s safer." },
        ],
        correctOption: "C",
      },
      {
        id: 9,
        question:
          "Which of the following would NOT support a growth mindset in schools?",
        options: [
          {
            id: "A",
            text: "Focusing instruction mainly on exam techniques and high-stakes results.",
          },
          {
            id: "B",
            text: "Giving students feedback that highlights their progress.",
          },
          {
            id: "C",
            text: "Encouraging students to reflect on their learning strategies.",
          },
          {
            id: "D",
            text: "Allowing space for productive struggle and experimentation.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 10,
        question:
          "Which teacher response best reflects grit when faced with consistently low student engagement and minimal support?",
        options: [
          {
            id: "A",
            text: "Recognizing that some students are not ready to learn and focusing energy on those who respond well.",
          },
          {
            id: "B",
            text: "Continuing to refine and test new approaches over time, driven by the belief that progress is possible.",
          },
          {
            id: "C",
            text: "Following the timetable strictly to meet administrative expectations, even if students aren't connecting.",
          },
          {
            id: "D",
            text: "Waiting for additional support or training before adjusting classroom practices.",
          },
        ],
        correctOption: "B",
      },
    ],
  },
  week5: {
    title: "Post-Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "What is the main goal of integrating SEL into teaching methods?",
        options: [
          {
            id: "A",
            text: "To make lessons less academically rigorous by focusing mainly on emotional sharing.",
          },
          {
            id: "B",
            text: "To manage student behavior more effectively by using SEL strategies as control tools.",
          },
          {
            id: "C",
            text: "To weave social and emotional learning into daily instruction so that it supports both academic and personal growth.",
          },
          {
            id: "D",
            text: "To treat SEL as an additional subject that’s separate from the core curriculum.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 2,
        question: "Which subject can SEL be integrated into?",
        options: [
          {
            id: "A",
            text: "Mainly literature, because it already explores characters’ emotions and relationships.",
          },
          {
            id: "B",
            text: "Primarily social studies, since it deals with communities and social issues.",
          },
          {
            id: "C",
            text: "Any subject area, as SEL skills can be developed through all learning experiences, even math and science.",
          },
          {
            id: "D",
            text: "Mostly creative classes like art and music, where self-expression is central.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question: "What is one way to integrate SEL into an English class?",
        options: [
          {
            id: "A",
            text: "Guiding students to connect personally with a text by examining characters’ decisions and emotions.",
          },
          {
            id: "B",
            text: "Emphasizing memorization of challenging vocabulary to build confidence in language skills.",
          },
          {
            id: "C",
            text: "Discussing literary techniques and grammar rules as a way to strengthen analytical thinking.",
          },
          {
            id: "D",
            text: "Asking students to write summaries that focus only on plot details to improve comprehension.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 4,
        question: "What is an example of using SEL in a Math class?",
        options: [
          {
            id: "A",
            text: "Helping students practice perseverance and manage frustration while working through challenging, multi-step problems.",
          },
          {
            id: "B",
            text: "Reminding students to control their emotions by not showing frustration and continuing to work.",
          },
          {
            id: "C",
            text: "Assessing students mainly on how quickly they finish and whether their final answers are correct.",
          },
          {
            id: "D",
            text: "Using mistakes as a reason to push students harder with stricter expectations and consequences.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 5,
        question: "What is the benefit of gamification in SEL teaching?",
        options: [
          { id: "A", text: "Builds competition, even if teamwork suffers." },
          { id: "B", text: "Offers a fun break from regular lessons." },
          {
            id: "C",
            text: "Boosts engagement, collaboration, and motivation.",
          },
          { id: "D", text: "Works best when games replace SEL content." },
        ],
        correctOption: "C",
      },
      {
        id: 6,
        question: "Which is a key feature of storytelling for SEL?",
        options: [
          {
            id: "A",
            text: "It helps students remember details through repetition.",
          },
          {
            id: "B",
            text: "It develops emotional literacy by encouraging empathy and self-reflection.",
          },
          {
            id: "C",
            text: "Keeps stories fictional to avoid real-life emotions.",
          },
          {
            id: "D",
            text: "Reduces emotional involvement to keep lessons objective.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 7,
        question:
          "What is one indicator that SEL is successfully integrated into classroom teaching?",
        options: [
          {
            id: "A",
            text: "SEL is mentioned in lesson plans, even if not practiced consistently during lessons.",
          },
          {
            id: "B",
            text: "Students apply emotional and social skills during academic tasks and classroom routines.",
          },
          {
            id: "C",
            text: "Teachers schedule weekly SEL check-ins, separate from academic content.",
          },
          {
            id: "D",
            text: "SEL is addressed only when emotional issues or conflict arise.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 8,
        question: "Which of the following is a SEL-aligned classroom routine?",
        options: [
          {
            id: "A",
            text: "Weekly restorative circles to reflect, reconnect, and build community.",
          },
          {
            id: "B",
            text: "Pop quizzes to keep students alert and accountable.",
          },
          {
            id: "C",
            text: "Rotational reading aloud to ensure participation.",
          },
          { id: "D", text: "Silent test review sessions to maintain order." },
        ],
        correctOption: "A",
      },
      {
        id: 9,
        question:
          "Why is it important to integrate SEL into classroom routines and subjects?",
        options: [
          {
            id: "A",
            text: "It keeps lessons running smoothly by minimizing disruptions and improving compliance.",
          },
          {
            id: "B",
            text: "It shifts the focus away from academics to manage emotions when issues come up.",
          },
          {
            id: "C",
            text: "It builds engagement, emotional safety, and the foundation for long-term academic growth.",
          },
          {
            id: "D",
            text: "It brings occasional change to routines without deeply affecting teaching practices.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 10,
        question:
          "All of the following are advantages of integrating SEL into teaching methods EXCEPT:",
        options: [
          {
            id: "A",
            text: "Strengthening classroom relationships and building trust among students.",
          },
          {
            id: "B",
            text: "Supporting both academic success and emotional well-being simultaneously.",
          },
          {
            id: "C",
            text: "Encouraging students to develop empathy, self-awareness, and responsible decision-making.",
          },
          {
            id: "D",
            text: "Reducing the need for intentional relationship-building by making students more independent.",
          },
        ],
        correctOption: "D",
      },
    ],
  },
  week6: {
    title: "Post-Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Which of the following is a key benefit of teaching Social and Emotional Learning and Positive Psychology in the classroom?",
        options: [
          {
            id: "A",
            text: "Helps students link emotional well-being to their overall learning and growth.",
          },
          {
            id: "B",
            text: "Raises test performance mainly by reducing academic rigor and pressure.",
          },
          {
            id: "C",
            text: "Encourages reliance on competition to motivate peer-to-peer achievement.",
          },
          {
            id: "D",
            text: "Decreases classroom time spent on building academic knowledge.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 2,
        question: "What does the SEL competency of self-awareness focus on?",
        options: [
          {
            id: "A",
            text: "Strengthening students’ ability to analyze and solve academic problems.",
          },
          {
            id: "B",
            text: "Supporting students in recognizing, understanding, and expressing their own emotions and values.",
          },
          {
            id: "C",
            text: "Building awareness of social issues and global perspectives.",
          },
          {
            id: "D",
            text: "Motivating students through healthy competition with peers.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question:
          "Which SEL competency focuses on managing stress and staying motivated in the face of challenges?",
        options: [
          { id: "A", text: "Self-awareness." },
          { id: "B", text: "Responsible decision-making." },
          { id: "C", text: "Self-management." },
          { id: "D", text: "Social awareness." },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question:
          "How can educators help students build social awareness in the classroom?",
        options: [
          {
            id: "A",
            text: "By creating activities that highlight shared goals while valuing individual perspectives.",
          },
          {
            id: "B",
            text: "By focusing strictly on academic mastery to reduce distractions.",
          },
          {
            id: "C",
            text: "By fostering healthy competition as the main way students learn about each other.",
          },
          {
            id: "D",
            text: "By modeling how to interpret and respond respectfully to the feelings of others.",
          },
        ],
        correctOption: "A",
      },
      {
        id: 5,
        question:
          "Which of the following practices is an example of effective emotional regulation in students?",
        options: [
          {
            id: "A",
            text: "Allowing students to share their feelings openly, even if it sometimes disrupts the class.",
          },
          {
            id: "B",
            text: "Guiding students to notice their emotional state and use techniques to respond constructively.",
          },
          {
            id: "C",
            text: "Giving students time to cool off by stepping back and not addressing their emotions immediately.",
          },
          {
            id: "D",
            text: "Encouraging students to stay focused on tasks by setting emotions aside until later.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 6,
        question: "How does gamification support SEL development?",
        options: [
          {
            id: "A",
            text: "By motivating students to complete tasks exactly as directed.",
          },
          {
            id: "B",
            text: "By boosting engagement while giving students a safe space to build resilience, teamwork, and sustained motivation.",
          },
          {
            id: "C",
            text: "By recognizing individual academic accomplishments above collaborative efforts.",
          },
          {
            id: "D",
            text: "By reducing competition through activities that limit interaction among students.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 7,
        question:
          "In which of the following scenarios would the SEL competency of relationship skills be most useful?",
        options: [
          { id: "A", text: "Solving complex algebraic problems in a group." },
          { id: "B", text: "Understanding how to manage stress in isolation." },
          {
            id: "C",
            text: "Navigating a group project where students must collaborate and communicate effectively.",
          },
          { id: "D", text: "Writing essays about personal experiences." },
        ],
        correctOption: "C",
      },
      {
        id: 8,
        question:
          "What is the first step in integrating SEL into your classroom routines?",
        options: [
          {
            id: "A",
            text: "Start by strengthening your own emotional regulation strategies as a teacher.",
          },
          {
            id: "B",
            text: "Prioritize academic instruction first and address emotional needs if they arise later.",
          },
          {
            id: "C",
            text: "Build a safe, trusting classroom environment where social and emotional learning can naturally take root.",
          },
          {
            id: "D",
            text: "Introduce SEL topics only when students show curiosity about them.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 9,
        question:
          "Which of the following is a key component of self-care for educators?",
        options: [
          {
            id: "A",
            text: "Pushing through stress by managing it quietly while maintaining all duties.",
          },
          {
            id: "B",
            text: "Setting clear boundaries and taking intentional time for emotional restoration.",
          },
          {
            id: "C",
            text: "Focusing entirely on students’ needs to keep the classroom running smoothly.",
          },
          {
            id: "D",
            text: "Staying constantly available to build deeper trust with students.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 10,
        question:
          "Why is it important for teachers to reflect on their own emotional triggers?",
        options: [
          {
            id: "A",
            text: "To reduce emotional discussions with students and keep lessons strictly academic.",
          },
          {
            id: "B",
            text: "To better address challenging behavior without letting personal emotions interfere.",
          },
          {
            id: "C",
            text: "To respond with composure and demonstrate healthy emotional regulation for students.",
          },
          {
            id: "D",
            text: "To prevent any outward emotional expression by keeping feelings completely hidden.",
          },
        ],
        correctOption: "C",
      },
    ],
  },
};
